import React, { useState } from 'react';
import { Button } from '@alifd/next';
import { EditServiceProps } from './types';
import AbsenceDialog from './components/AbsenceDialog';

const EditService: React.FC<EditServiceProps> = ({ buttonProps }) => {
  const [showDialog, setShowDialog] = useState(false);
  return (
    <>
      <Button
        {...(buttonProps || {})}
        onClick={() => setShowDialog(true)}
        style={{ marginLeft: 10 }}
      >
        編輯請假類型
      </Button>
      <AbsenceDialog showDialog={showDialog} setShowDialog={setShowDialog} />
    </>
  );
};

export default EditService;
